/**
 * 区分 roundingType（contracts.rounding_type）
 * 出典：仕様書に値なし（円未満）
 * 【仮置き】入力文書に値が無い。業務側の確認で差し替える
 */
export const ROUNDING_TYPE_VALUES = ['round', 'floor', 'ceil'] as const;

export type RoundingType = (typeof ROUNDING_TYPE_VALUES)[number];

export const ROUNDING_TYPE_LABELS: Readonly<Record<RoundingType, string>> = {
  round: '四捨五入',
  floor: '切り捨て',
  ceil: '切り上げ',
};
